export const CATEGORY_LIST 	= "CATEGORY_LIST";
export const DASHBOARD_COUNT = "DASHBOARD_COUNT";